import { MarketplaceAutoManagedCampaignList, MarketplaceAutoManagedCampaignFilter } from '@anytag/shared-organisms';

export const MarketplaceAutoManagedCampaigns = () => (
  <>
    <MarketplaceAutoManagedCampaignFilter />
    <MarketplaceAutoManagedCampaignList />
  </>
);
